<script>
import * as restfulService from '../../../services/restfulService'

import bus from '@utils/bus'
import helpers from '@mixins/helper'

export default {
  mixins: [helpers],
  name: 'pagar-online',
  props: ['titulo'],
  data () {
    return {
      refPedido: null,
      valorPedido: null,
      urlPagamento: '',
      mostrarModal: false
    }
  },
  computed: {
    habilitarPagamentoOnline () {
      return this.titulo.mostrar_boleto && this.titulo.saldo && Math.sign(this.titulo.saldo) > 0 && this.titulo.cod_boleto !== null && this.titulo.mostrar_pagamento_online
    },
    isMobileSize: function () {
      return this.isMobile().any()
    }
  },
  methods: {
    gerarLinkPagamento () {
      bus.$emit('show-loader', {message: 'Gerando pedido de pagamento, aguarde...'})

      restfulService.get('titulo', 'gerar-link-pagamento', this.titulo.id)
        .then((response) => {
          bus.$emit('hide-loader')

          this.refPedido = response.id
          this.valorPedido = response.valor
          this.urlPagamento = response.url_pagamento

          this.mostrarModal = true
          window.open(this.urlPagamento, '_blank')
        })
        .catch(e => {
          bus.$emit('hide-loader')
          console.log(e)
        })
    }
  }
}
</script>

<template>
  <div>
    <v-btn color="success"
           fab small
           :depressed="true"
           v-if="habilitarPagamentoOnline"
           title="Pagar online"
           @click="gerarLinkPagamento">
      <i class="fas fa-credit-card"></i>
    </v-btn>
    <v-dialog v-model="mostrarModal" :width="isMobileSize ? '90%' : '50%'">
      <v-card>
        <v-container>
          <h3 class="pb-3" :class="{'display-1': !isMobileSize}">
            Pagamento online
          </h3>
          <div :class="{'body-1': isMobileSize, 'subheading': !isMobileSize}">
            <p>
              O pedido nº <strong>{{refPedido}}</strong> no valor de
              <strong>R$ {{valorPedido | currencyEnToBr}}</strong> foi gerado com sucesso. Caso não tenha aberto uma
              janela no seu navegador, clique no link abaixo para efetuar o pagamento.
            </p>
            <div class="text-xs-center">
              <strong>Link para pagamento:</strong><br>
              <a :href="urlPagamento" target="_blank">{{ urlPagamento }}</a>
            </div>
          </div>
        </v-container>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="mostrarModal = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



// WEBPACK FOOTER //
// PagarOnline.vue?52f5ae55